module.exports = __webpack_public_path__ + "static/media/robotech.d986cdf6.png";